import React from 'react';
import { MapPin, Plane } from 'lucide-react';
import { majorAirports } from '../../../data/airports/majorAirports';
import { formatAirportLabel } from '../../../data/airports/utils';

interface CurrentAirportProps {
  selectedAirport: string;
}

export function CurrentAirport({ selectedAirport }: CurrentAirportProps) {
  const airport = majorAirports.find(a => a.id === selectedAirport);
  
  if (!airport) return null;

  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-50 via-blue-50 to-primary-50"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=2000')] bg-cover bg-center opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-3">
        <div className="flex items-center justify-center gap-2 sm:gap-3">
          <div className="flex items-center gap-1.5 sm:gap-2 text-primary-700">
            <div className="p-1 sm:p-1.5 bg-primary-100 rounded-lg">
              <Plane size={12} className="text-primary-600 sm:w-4 sm:h-4" />
            </div>
            <span className="text-xs sm:text-sm font-semibold">Currently viewing:</span>
          </div>
          
          <div className="flex items-center gap-1.5 sm:gap-2 px-3 py-1 sm:px-4 sm:py-1.5 bg-white/80 backdrop-blur-sm rounded-full border border-primary-200/50 shadow-sm">
            <MapPin size={12} className="text-primary-600 sm:w-3.5 sm:h-3.5" />
            <span className="text-xs sm:text-sm font-medium text-primary-800">
              {formatAirportLabel(airport)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}